import React, { useCallback, useEffect, useState } from 'react'

import { Box, Button, ToggleButton, Typography } from '@mui/material';
import MaleIcon from '@mui/icons-material/Male';
import FemaleIcon from '@mui/icons-material/Female';
import { styled } from "@mui/material/styles";
import _ from 'lodash'
import DefaultEntityCrud from 'components/form/DefaultEntityCrud';
import FormContent from 'components/form/FormContent';
import FormRow from 'components/form/FormRow';
import SelectInput from 'components/form/input/SelectInput';
import SelectButtonInput from 'components/form/input/SelectButtonInput';
import TextInput from 'components/form/input/TextInput';
import AutocompleteInput from 'components/form/input/AutocompleteInput';
import DateInput from 'components/form/input/DateInput';
import TabContainer from 'components/tabs/TabContainer';
import TabPanel from 'components/tabs/TabPanel';
import { fetchArray } from 'entity';
import NascimentoEntity from 'entity/Nascimento';
import SeletorFazendas from 'entity/Fazenda/components/SeletorFazendas';
import { useNavigate } from 'react-router-dom';
import useNotification from 'notification';
import { useForm } from "react-final-form"


const ToggleButtonselectedcolor = styled(ToggleButton)(({ selectedcolor, colort }) => ({
    "&.Mui-selected, &.Mui-selected:hover": {
        color: colort || "white",
        backgroundColor: selectedcolor
    }
}));

function NascimentoFormInter(props) {

    const navigate = useNavigate();
    const { setInicialValues, verificaPosSave, setVerificaPosSave } = props

    const { statusBezerro, fazenda, status } = props.values || {}
    const [tab, setTab] = useState(0)
    const [retirosAnteriores, setRetirosAnteriores] = useState([])

    const [habilitaGemelar, setHabilitaGemelar] = useState(false)
    const [numBezerroRequired, setNumBezerroRequired] = useState(true)
    const [posSaveAction, setPosSaveAction] = useState(null)

    const form = useForm()

    useEffect(() => {
        if (!status) {
            form.change('status', 'ATIVO');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (verificaPosSave) {
            setVerificaPosSave(false)
            if (posSaveAction) {
                posSaveAction()
                setPosSaveAction(null)
            }
        }
        return () => {
            setVerificaPosSave(false)
        };

    }, [posSaveAction, setVerificaPosSave, verificaPosSave])

    async function saveNew() {
        setPosSaveAction(() => {
            return () => {
                const fazenda = props.values.fazenda
                const matriz = props.values.matriz
                matriz.numero = ""
                matriz.era = ""
                matriz.raca = ""
                let newN = { fazenda, matriz, data: props.values.data }
                setTab(0)
                setInicialValues(newN)
                props.form.initialize(newN)
                navigate("/nascimento")
            }
        })

        let pSalvar = props.form.submit()
        if (pSalvar) {
            pSalvar.then((foi) => {
                console.log('foi')
            }
            )
        }
    }

    async function finish() {
        setPosSaveAction(() => {
            return () => {
                navigate("/")
            }
        })
        let pSalvar = props.form.submit()
        if (pSalvar) {
            pSalvar.then(() =>
                console.log('foi')
            )
        }
    }
    const buscaRetiros = useCallback(async (fazenda) => {
        if (fazenda) {
            // console.log('buscaRetiros')
            let query1 = await NascimentoEntity.collection
                .where("fazenda.uid", "==", fazenda.uid)
            let nascimentoS = await fetchArray(query1.get());
            let retiros = []
            nascimentoS.forEach(n => {
                if (n.matriz.retiro && !retiros.includes(n.matriz.retiro)) {
                    retiros.push(n.matriz.retiro)
                }
            })
            setRetirosAnteriores(retiros)
        } else {
            setRetirosAnteriores([])
        }
    }, [])

    useEffect(() => {
        buscaRetiros(fazenda)
        return () => { }
    }, [buscaRetiros, fazenda])

    useEffect(() => {
        if (statusBezerro === "GEMELAR") {
            setHabilitaGemelar(true)
        } else {
            setHabilitaGemelar(false)
        }

        if (statusBezerro === "ABORTO" || statusBezerro === "NATIMORTO") {
            setNumBezerroRequired(false)
        } else {
            setNumBezerroRequired(true)
        }

        return () => { }
    }, [statusBezerro])



    return <TabContainer tab={tab} changeTab={setTab}>

        <TabPanel label="Matriz" sx={{ m: 1 }}>
            <FormContent>
                <FormRow>
                    <SelectInput
                        sx={{ flex: 1, marginBottom: 4 }}
                        name="status"
                        label="Status"
                        options={["ATIVO", "CANCELADO"]}
                        helperText={"*Escolha CANCELADO p/ excluir esse nascimento e ATIVO p/ mantê-lo"}
                    />
                </FormRow>
                <FormRow>
                    <SeletorFazendas
                        name="fazenda"
                        label="Fazenda"
                        loadOnRender
                        autoSelectOne
                        required
                    />
                </FormRow>

                <FormRow noWhap>
                    <TextInput
                        name="matriz.numero"
                        label="Nº da Matriz"
                        InputProps={{ style: { fontSize: 32 } }}
                        required
                    />
                    <TextInput type="number" name="matriz.era" label="ERA" InputProps={{ style: { fontSize: 32 } }} />
                </FormRow>
                <FormRow>
                    <SelectButtonInput
                        name="matriz.raca"
                        label="Raça"
                        required
                    >
                        <ToggleButtonselectedcolor sx={{ flex: 1 }} selectedcolor="#e5e5e5" colort="#000" value={'NELORE'}>
                            NELORE
                        </ToggleButtonselectedcolor>
                        <ToggleButtonselectedcolor sx={{ flex: 1 }} selectedcolor="#000" value={'CRUZADO'}>
                            CRUZADO
                        </ToggleButtonselectedcolor>
                    </SelectButtonInput>
                </FormRow>
                <FormRow>

                    <TextInput name="matriz.lote" label="Lote" />
                </FormRow>

                <FormRow>
                    <AutocompleteInput name="matriz.retiro" label="Retiro"
                        options={retirosAnteriores}
                        freeSolo
                    // getOptionLabel={(option) => option.nome || ""}
                    // isOptionEqualToValue={(option, value) => option.nome === value.nome}
                    />
                </FormRow>


                <div style={{ display: "flex", flex: 1, justifyContent: 'center', marginBottom: 50 }}>

                    <Button sx={{ mt: 3 }} onClick={() => setTab(1)}>Proximo</Button>
                </div>
            </FormContent>
        </TabPanel>

        <TabPanel label="Bezerro" sx={{ m: 1 }}>
            <FormContent>
                <FormRow noWhap>
                    <DateInput name="data" label="Data de Nascimento" required />
                    <SelectInput
                        required
                        sx={{ flex: 1 }}
                        name="statusBezerro"
                        label="Status"
                        options={["ATIVO", "ABORTO", "NATIMORTO", "TE", "GEMELAR"]}
                    // onSelectItem={setStatusB}
                    />
                </FormRow>
                <Box sx={{
                    width: "100%",
                    backgroundColor: habilitaGemelar ? "rgba(0,0,0,0.1)" : "unset"
                }}>
                    <Typography
                        variant="h6"
                        sx={{ color: 'text.secondary', display: habilitaGemelar ? "block" : "none" }}
                    >
                        Bezerro 1
                    </Typography>
                    <FormRow noWhap>
                        <TextInput name="numBezerro" label="Número do Bezerro" required={numBezerroRequired} />
                        <TextInput type="number" name="peso" label="Peso (KG)" />
                    </FormRow>
                    <FormRow>
                        <SelectButtonInput
                            name="sexo"
                            label="Sexo"
                            required
                        >
                            <ToggleButtonselectedcolor sx={{ flex: 1 }} selectedcolor="#00abc0" value={'MACHO'}>
                                <MaleIcon /> MACHO
                            </ToggleButtonselectedcolor>
                            <ToggleButtonselectedcolor sx={{ flex: 1 }} selectedcolor="#eb83b5" value={'FEMEA'}>
                                <FemaleIcon />  FEMEA
                            </ToggleButtonselectedcolor>
                        </SelectButtonInput>
                    </FormRow>
                </Box>
                {habilitaGemelar && <Box sx={{
                    width: "100%",
                    backgroundColor: "rgba(0,0,0,0.1)"
                }}>
                    <Typography
                        variant="h6"
                        sx={{ color: 'text.secondary' }}
                    >
                        Bezerro 2
                    </Typography>
                    <FormRow noWhap>
                        <TextInput name="gemelar.numBezerro" label="Número do Bezerro" required />
                        <TextInput type="number" name="gemelar.peso" label="Peso (KG)" />
                    </FormRow>
                    <FormRow>
                        <SelectButtonInput
                            name="gemelar.sexo"
                            label="Sexo"
                            required
                        >
                            <ToggleButtonselectedcolor sx={{ flex: 1 }} selectedcolor="#00abc0" value={'MACHO'}>
                                <MaleIcon /> MACHO
                            </ToggleButtonselectedcolor>
                            <ToggleButtonselectedcolor sx={{ flex: 1 }} selectedcolor="#eb83b5" value={'FEMEA'}>
                                <FemaleIcon />  FEMEA
                            </ToggleButtonselectedcolor>
                        </SelectButtonInput>
                    </FormRow>
                </Box>}


                <FormRow>
                    <SelectButtonInput
                        name="raca"
                        label="Raça"
                        required
                    >
                        <ToggleButtonselectedcolor sx={{ flex: 1 }} selectedcolor="#e5e5e5" colort="#000" value={'NELORE'}>
                            NELORE
                        </ToggleButtonselectedcolor>
                        <ToggleButtonselectedcolor sx={{ flex: 1 }} selectedcolor="#000" value={'CRUZADO'}>
                            CRUZADO
                        </ToggleButtonselectedcolor>
                    </SelectButtonInput>
                </FormRow>

                <FormRow>
                    <TextInput name="obsParto" label="Observação" multiline={true} />
                </FormRow>

                <FormRow>
                    <div style={{ display: 'flex', flex: 1, flexWrap: 'wrap', justifyContent: "space-evenly", marginBottom: 50 }}>
                        <Button onClick={saveNew} style={{ margin: 20 }}>Salvar e Novo</Button>
                        <Button onClick={finish} style={{ margin: 20 }}>Finalizar Digitação</Button>
                    </div>
                </FormRow>
            </FormContent>

        </TabPanel>

    </TabContainer>
}

export default function NascimentoForm() {
    const { showSuccess/*, showWarning*/ } = useNotification()
    const navigate = useNavigate();
    const [inicialValues, setInicialValues] = useState({})
    const [verificaPosSave, setVerificaPosSave] = useState(null)

    const overSaveValues = (values) => {
        let entityGemelar = null
        let entity = new NascimentoEntity()
        entity.update(values);
        if (values.statusBezerro === 'GEMELAR') {
            entityGemelar = new NascimentoEntity()
            let gemalarValues = _.cloneDeep(values);
            gemalarValues.numBezerro = values.gemelar.numBezerro
            gemalarValues.peso = values.gemelar.peso || null
            gemalarValues.sexo = values.gemelar.sexo

            gemalarValues.gemelar.numBezerro = values.numBezerro
            gemalarValues.gemelar.peso = values.peso || null
            gemalarValues.gemelar.sexo = values.sexo

            gemalarValues.uid = values.gemelar.uid
            gemalarValues.gemelar.uid = values.uid
            entityGemelar.update(gemalarValues);

            // eslint-disable-next-line no-unused-vars
            let refAux = entity.doc;
            // eslint-disable-next-line no-unused-vars
            let refAux2 = entityGemelar.doc;

            entityGemelar.data.gemelar.uid = entity.data.uid
            entity.data.gemelar.uid = entityGemelar.data.uid



        }


        entity.save().then(() => {
            // console.log('salvou')
            showSuccess("Salvo com Sucesso")
            setVerificaPosSave(true)
            navigate("/nascimento?uid=" + entity.data.uid);
        })
        if (entityGemelar) {
            entityGemelar.save().then(() => {
                showSuccess("Salvo Gemelar com Sucesso")
            })
        }
    }

    return (
        <DefaultEntityCrud
            EntityClass={NascimentoEntity}
            title={"Nascimento"}
            routeForm="nascimento"
            backRoute="consultaNascimentos"
            inicialValues={inicialValues}
            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
            overSaveValues={overSaveValues}
            posSaveAction={() => {
                console.log('SALLLLVOOOUUUUUU')
                setVerificaPosSave(true)
            }}
        >
            {(props) => {
                return <NascimentoFormInter {...props}
                    verificaPosSave={verificaPosSave}
                    setVerificaPosSave={setVerificaPosSave}
                    inicialValues={inicialValues} setInicialValues={setInicialValues} />
            }}
        </DefaultEntityCrud>
    )
}